// tslint:disable:max-line-length
import React from 'react';

interface PlaneIconProps extends React.SVGProps<SVGSVGElement> {
    rotate?: number;
}

const PlaneIcon: React.SFC<PlaneIconProps> = props => (
    <svg viewBox="0 0 100 100" transform={`rotate(${props.rotate || 0})`}>
        <path
            fill="currentColor"
            d="M9.9,48.7l-4.8,17L11,66l8.4-12.8c6.1,1.7,15.8,3.2,28.1,3.9l1.1,0l-11.2,35l6.1,0.2L66,57.8l9,0.3c10.8,0.3,19.7-2.5,19.9-6.4c0.1-3.9-8.5-7.3-19.4-7.6l-9-0.3L46.3,7.9l-6.1-0.2L49,43.3L48,43.2c-12.4-0.1-22.3,0.7-28.4,2l-7.4-13.1l-5.9-0.3L9.9,48.7z"
        />
    </svg>
);
export { PlaneIcon };
